module.exports = __webpack_public_path__ + "img/symbol_8.f3aa33f8.png";